import f from "./objectWithoutPropertiesLoose.mjs";
import r from "./extends.mjs";
import * as d from "react";
import o from "./index180.mjs";
import { clsx as g } from "./clsx.mjs";
import u from "./styled.mjs";
import b from "./useThemeProps.mjs";
import { getDialogActionsUtilityClass as y } from "./dialogActionsClasses.mjs";
import { jsx as x } from "react/jsx-runtime";
import S from "./composeClasses.mjs";
const D = ["className", "disableSpacing"], A = (s) => {
  const {
    classes: t,
    disableSpacing: e
  } = s;
  return S({
    root: ["root", !e && "spacing"]
  }, y, t);
}, j = u("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (s, t) => {
    const {
      ownerState: e
    } = s;
    return [t.root, !e.disableSpacing && t.spacing];
  }
})(({
  ownerState: s
}) => r({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !s.disableSpacing && {
  "& > :not(:first-of-type)": {
    marginLeft: 8
  }
})), a = /* @__PURE__ */ d.forwardRef(function(t, e) {
  const i = b({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: c,
    disableSpacing: l = !1
  } = i, p = f(i, D), n = r({}, i, {
    disableSpacing: l
  }), m = A(n);
  return /* @__PURE__ */ x(j, r({
    className: g(m.root, c),
    ownerState: n,
    ref: e
  }, p));
});
process.env.NODE_ENV !== "production" && (a.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const P = a;
export {
  P as default
};
//# sourceMappingURL=DialogActions2.mjs.map
